// extracted by mini-css-extract-plugin
export default {"layoutContainer":"Layout_layoutContainer__hSJfe","mainWrapper":"Layout_mainWrapper__rQWMr","content":"Layout_content__Knhk2"};